import React from 'react'
import { useSelector } from 'react-redux';
import styled from 'styled-components'

const Promps = () => {
    const user = useSelector(state => state.auth.user);
    const isDark = useSelector(state => state.utils.isDarkMode);
    const remainingPrompts = useSelector(state => state.chat.remainingPrompts);
    const remainingReferrals = useSelector(
        state => state.chat.remainingReferrals
    );
  return (
      <Container className='prompt-container' isDark={isDark}>
          {user?.profile?.status === 2 || remainingReferrals > 0
              ? 'Unlimited prompts'
              : remainingPrompts + ' prompts'}
      </Container>
  )
}

export default Promps

const Container = styled.div`
    font-weight: 400;
    font-size: 13px;
    line-height: 19.5px;
    font-family: Poppins;
    font-weight: bold;
    background: ${({ isDark }) => isDark ? 'linear-gradient(95.23deg, #7E3FE4 -6.59%, #DF3587 32.62%, #FE395C 71.84%, #FB9631 111.05%)' : 'rgba(32, 33, 36, 1)'};

    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
`